import TextArea, { TextAreaProps } from 'antd/es/input/TextArea';
import React, { forwardRef } from 'react';


const CustomTextArea = forwardRef<HTMLTextAreaElement, TextAreaProps>((props, ref) => {
  return (
  <TextArea {...props} ref={ref} />);
});

export default CustomTextArea;
